// extracted by mini-css-extract-plugin
export default {"wrapper-moreinfo":"Menu_wrapper-moreinfo__j57xH"};